import type { Location } from 'modules/core/lib/navigation/types'

import { navigation as content } from 'modules/trainings/lib/contentNavigation'

export const navigation = {
  path: 'trainings',
  children: {
    list: {
      path: 'list',
      size: 'full',
      children: {
        index: {
          path: 'index',
          children: {
            bulk_update_catalog_visible: {
              path: 'bulk_update_catalog_visible',
              size: 'full',
            },
            bulk_update_catalog_remove: {
              path: 'bulk_update_catalog_remove',
              size: 'full',
            },
            new: {
              size: 'full',
              path: 'new',
            },
            duplicate: {
              size: 'full',
              path: 'duplicate/:id',
            },
            delete: {
              size: 'full',
              path: 'delete/:id',
            },
            updateCatalog: {
              size: 'full',
              path: 'update-catalog/:id',
            },
            export: {
              size: 'full',
              path: 'export',
            },
          },
        },
        details_revamp: {
          path: ':id',
          children: {
            view: {
              path: 'detail',
              size: 'full',
              children: {
                overview: {
                  path: 'overview',
                },
                participants: {
                  path: 'participants',
                  children: {
                    employees: {
                      path: 'employee/:employeeId',
                      children: {
                        previewCertificate: {
                          path: ':trainingMembershipId/certificate/view/:trainingMembershipFileId',
                          size: 'full',
                        },
                        uploadCertificate: {
                          path: 'uploadCertificate/:trainingMembershipId',
                        },
                      },
                    },
                    addParticipants: {
                      path: 'addParticipants',
                    },
                    assignParticipants: {
                      path: 'assign',
                    },
                    assignParticipant: {
                      path: 'assign/:accessId',
                    },
                    deleteParticipant: {
                      path: 'delete/:membershipId',
                    },
                    deleteParticipants: {
                      path: 'delete',
                    },
                    updateCompletionDate: {
                      path: 'update/:membershipId',
                    },
                  },
                },
                trainingClasses: {
                  path: 'classes',
                  children: {
                    detail: {
                      path: ':classId',
                      children: {
                        event: {
                          path: 'event/:eventId',
                          children: {
                            view: {
                              path: 'view',
                              children: {
                                deleteEvent: {
                                  path: 'deleteEvent',
                                },
                              },
                            },
                          },
                        },
                        newClass: {
                          path: 'new-class',
                        },
                        deleteClass: {
                          path: 'deleteClass',
                        },

                        duplicateClass: {
                          path: 'duplicate-class',
                        },

                        editClass: {
                          path: 'editClass',
                        },
                        sessions: {
                          path: 'sessions',
                          children: {
                            delete: {
                              path: 'delete/:eventId',
                            },
                            deleteClass: {
                              path: 'deleteClass',
                            },
                            editClass: {
                              path: 'editClass',
                            },
                            create: {
                              path: 'create',
                            },
                            attendance: {
                              path: 'attendance',
                              children: {
                                event: {
                                  path: ':eventId',
                                },
                              },
                            },
                            edit: {
                              path: 'edit/:eventId',
                            },
                          },
                        },
                        participants: {
                          path: 'participants',
                          children: {
                            add: {
                              path: 'add',
                            },
                          },
                        },
                        materials: {
                          path: 'materials',
                          children: {
                            newFile: {
                              path: 'new',
                            },
                            newLink: {
                              path: 'new-link',
                              size: 'full',
                            },
                            previewFile: {
                              path: 'view/:classFileId',
                              size: 'full',
                            },
                          },
                        },
                        documents: {
                          path: 'documents',
                          children: {
                            newFile: {
                              path: 'new',
                            },
                            previewFile: {
                              path: 'view/:classFileId',
                              size: 'full',
                            },
                          },
                        },
                        costs: {
                          path: 'costs',
                        },
                      },
                    },
                    tab: {
                      path: 'tab',
                      children: {
                        event: {
                          path: ':classId/event/:eventId',
                          children: {
                            view: {
                              path: 'view',
                              children: {
                                deleteEvent: {
                                  path: 'deleteEvent',
                                },
                              },
                            },
                          },
                        },
                        editClass: {
                          path: ':classId/editClass',
                        },
                        editClassModal: {
                          path: ':classId/editClassModal',
                        },
                        newClass: {
                          path: 'new-class',
                        },
                        deleteClass: {
                          path: ':classId/deleteClass',
                        },

                        duplicateClass: {
                          path: ':classId/duplicate-class',
                        },
                      },
                    },
                  },
                },
                attachments: {
                  path: 'attachments',
                  children: {
                    newFile: {
                      path: 'new',
                    },
                    previewFile: {
                      path: 'view/:fileId',
                      size: 'full',
                    },
                    newLink: {
                      path: 'new-link',
                      size: 'full',
                    },
                  },
                },
                documents: {
                  path: 'documents',
                  children: {
                    newFile: {
                      path: 'new',
                    },
                    previewFile: {
                      path: 'view/:fileId',
                      size: 'full',
                    },
                  },
                },
                startTraining: {
                  path: 'startTraining',
                },
                stopTraining: {
                  path: 'stopTraining',
                },
                surveys: {
                  path: 'surveys',
                  children: {
                    newSurvey: {
                      path: 'newSurvey',
                    },
                    select: {
                      path: 'select',
                    },
                    selectCustomTemplate: {
                      path: 'selectCustomTemplate',
                    },
                    delete: {
                      size: 'full',
                      path: 'delete/:formId',
                    },
                  },
                },
                // This is for specific usage of Spanish customers
                fundae: {
                  path: 'fundae',
                  children: {
                    educationLevel: {
                      path: 'educationlevel',
                    },
                    professionalCategory: {
                      path: 'professionalcategory',
                    },
                  },
                },
              },
            },
            trainingClassDetail: {
              path: ':classId/classDetails',
            },
            trainingSurveyDetail: {
              path: ':formId/surveyDetails',
              children: {
                settings: {
                  path: 'settings',
                },
                questions: {
                  path: 'questions',
                  children: {
                    sendSurvey: {
                      path: 'send-survey',
                    },
                    delete: {
                      size: 'full',
                      path: 'delete/:formId',
                    },
                    blockedSend: {
                      size: 'full',
                      path: 'blocked-send-survey',
                    },
                  },
                },
                responses: {
                  path: 'responses',
                },
                edit: {
                  size: 'full',
                  path: 'edit',
                },
              },
            },
            editTraining: {
              path: 'edit',
              size: 'full',
              children: {
                view: {
                  path: '',
                  children: {
                    courseValidityUnCheck: {
                      path: 'course-validity-uncheck-modal',
                    },
                  },
                },
              },
            },
            relatorioUnico: {
              path: 'relatorioUnico',
            },
            content: content,
          },
        },
        categories: {
          path: 'categories',
          children: {
            new: {
              path: 'new',
            },
            deleteCategory: {
              path: 'delete/:id',
            },
          },
        },
        surveyTemplates: {
          path: 'survey-templates',
          children: {
            list: {
              path: 'list',
              children: {
                newTemplate: {
                  path: 'new-template',
                },
              },
            },
            templateDetails: {
              path: ':templateId/template-details',
              children: {
                questions: {
                  path: 'questions',
                },
                edit: {
                  path: 'edit',
                },
              },
            },
          },
        },
      },
    },
    insights: {
      path: 'insights',
    },
    requests: {
      path: 'requests',
      children: {
        list: {
          path: 'list',
          children: {
            fromCatalog: {
              path: 'from-catalog',
            },
            new: {
              path: 'new',
            },
          },
        },
        detail: {
          path: ':id',
          children: {
            view: {
              path: 'view',
            },
          },
        },
      },
    },
    catalog: {
      path: 'catalog',
      children: {
        list: {
          path: 'list',
          children: {
            fromCatalog: {
              path: ':id/from-catalog',
            },
            new: {
              path: 'new',
            },
            selectTraining: {
              path: 'select',
            },
          },
        },
        detail: {
          path: 'list/:trainingId',
          children: {
            overview: {
              path: 'overview',
            },
            fromCatalog: {
              path: 'from-catalog',
            },
            materials: {
              path: 'materials',
              children: {
                previewFile: {
                  path: 'view/:fileId/:fileType',
                  size: 'full',
                },
                certificate: {
                  path: 'upload-certificate',
                },
              },
            },
            sessions: {
              path: 'sessions',
              children: {
                sidepanel: {
                  path: ':sessionId/session-detail',
                },
              },
            },
          },
        },
      },
    },
  },
} as const satisfies Location
